import _ from "../../../../shared/utils/lodash";
import stripHtml from "../stripHtml";
export var schemaDescription = function (review, poiType) {
    var plainTextReview = stripHtml(review);
    if (poiType === "eating") {
        return _.truncate(plainTextReview, {
            length: 200,
            omission: "…",
        });
    }
    return plainTextReview;
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/schema/schemaDescription.ts
// module id = xpuk
// module chunks = 2